import { Route, Routes } from 'react-router-dom';

import { Headline } from 'components/Headline';

import { LoginForm } from './components/LoginForm';
import { SignupForm } from './components/SignupForm';
import { NewPasswordForm } from './components/NewPasswordForm';
import { ForgotPassword } from './components/ForgotPassword';

import * as S from './Login.styles';

export function LoginPage(): React.ReactElement {
  return (
    <S.Container>
      <S.Title
        fontFamily="LFT Zeno Condensed"
        tag="h1"
        scale="xl5"
        textTransform="uppercase"
        color="white"
        fontWeight="normal"
      >
        colmar
      </S.Title>

      <S.Wrapper>
        <Routes>
          <Route path="/" element={<LoginForm />} />

          <Route path="/signup" element={<SignupForm />} />

          <Route path="/new-password" element={<NewPasswordForm />} />

          <Route path="/forgot-password" element={<ForgotPassword />} />
        </Routes>

        <S.Footer>
          <Headline
            textAlign="center"
            color="borderColorDarkSecondary"
            fontWeight="light"
            scale="xs"
            fontFamily="LFT Zeno"
          >
            Copyrights © All Rights Reserved by Manifattura Mario Colombo &#38; C.
          </Headline>

          <Headline
            textAlign="center"
            color="borderColorDarkSecondary"
            fontWeight="light"
            scale="xs"
            fontFamily="LFT Zeno"
          >
            v 3.0.0
          </Headline>
        </S.Footer>
      </S.Wrapper>
    </S.Container>
  );
}
